import React from 'react';
import { ResidentPageType } from '@typings/ResidentTypes';
import './styles.scss';

interface NavigationProps {
  type: ResidentPageType;
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const Navigation: React.FC<NavigationProps> = ({
  type,
  currentStep,
  setCurrentStep,
}) => {
  const steps = [
    { id: 1, title: 'Add / edit' },
    { id: 2, title: 'Required' },
    { id: 3, title: 'About me' },
    { id: 4, title: 'End of Life' },
    { id: 5, title: 'Conversations' },
    { id: 6, title: 'Sharing' },
  ];

  const disabledSteps = [2, 3, 4, 5, 6];

  const handleClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    stepId: number
  ) => {
    e.preventDefault();
    if (!disabledSteps.includes(stepId) || type === ResidentPageType.EDIT) {
      setCurrentStep(stepId);
    }
  };

  return (
    <div
      className="govuk-service-navigation"
      data-module="govuk-service-navigation"
    >
      <div className="govuk-width-container">
        <div className="govuk-service-navigation__container">
          <nav
            aria-label="Menu"
            className="govuk-service-navigation__wrapper px-3"
          >
            <ul className="govuk-service-navigation__list" id="navigation">
              {steps.map(step => {
                const isDisabled =
                  type === ResidentPageType.ADD &&
                  disabledSteps.includes(step.id);
                return (
                  <li
                    key={step.id}
                    className={`govuk-service-navigation__item ${currentStep === step.id ? 'govuk-service-navigation__item--active' : ''} ${
                      isDisabled
                        ? 'govuk-service-navigation__item--disabled'
                        : ''
                    }`}
                  >
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a
                      onClick={e => handleClick(e, step.id)}
                      className={`govuk-service-navigation__link ${
                        isDisabled
                          ? 'govuk-service-navigation__link--disabled'
                          : ''
                      }`}
                      href=""
                      aria-disabled
                      aria-current={currentStep === step.id}
                    >
                      {currentStep === step.id ? (
                        <strong className="govuk-service-navigation__active-fallback">
                          {step.title}
                        </strong>
                      ) : (
                        step.title
                      )}
                    </a>
                  </li>
                );
              })}
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
